import { createSelector } from 'reselect'
import currentUserRolesSelector from 'selectors/currentUserRoles'
import makeLayoutPermissionSelector from '../../selectors/makeLayoutPermissionSelector'

export const getLayout = (state, props) => {
  return state['view-home'].layouts.byId[props.layoutId]
}

export const geLayoutId = (state, props) => {
  return props.layoutId
}

export default () => {
  const layoutPermissionSelector = makeLayoutPermissionSelector()

  return createSelector(
    [
      currentUserRolesSelector,
      layoutPermissionSelector,
      getLayout,
    ],
    (
      currentUserRoles,
      permission,
      layout,
    ) => ({
      currentUserRoles,
      permission,
      layout,
    })
  )
}
